module.exports = __webpack_public_path__ + "static/media/taiwan.8ea0b61c.svg";